<template>
  <div>
    <!-- 自定义导航 -->
    <Nav></Nav>
    <!-- 自定义导航-->
    <div class="reset-action">
      <div class="reset-title">找回密码</div>
      <div class="input-wrap">
        <img src="../../../assets/img/login_btn_phone.png" alt="">
        <input type="text" placeholder="请输入手机号码" v-model="phone" @input="checkPhone">
        <img v-show="phone" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('phone')">
      </div>
      <div class="code-wrap">
        <div class="text-wrap">
          <img src="../../../assets/img/login_btn_validation.png" alt="">
          <input type="text"  v-model="code" placeholder="请输入验证码">
        </div>
        <div v-show="!showCountDown" class="code-btn" @click="sendSms">
          获取验证码
        </div>
        <div v-show="showCountDown" class="clock-btn">
          重新发送({{countDown}})s
        </div>
      </div>
      <div class="input-wrap">
        <img src="../../../assets/img/login_btn_password.png" alt="">
        <input type="password" placeholder="设置新密码" v-model="password">
        <img v-show="password" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('password')">
      </div>
      <div class="input-wrap">
        <img src="../../../assets/img/login_btn_password.png" alt="">
        <input type="password" placeholder="确认登录密码" v-model="repassword">
        <img v-show="repassword" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('repassword')">
      </div>
      <div class="go-reset" @click="handleSubmit">修改密码</div>
    </div>
  </div>
</template>
<script>
  import Nav from '@/components/h5/Nav.vue'
  import { forgetPwdSms, forgetPwd, getUserInfo, setting } from '@/api/user'
  export default {
      name: 'Home',
      components: {
        Nav
      },
      data() {
        return {
          nickname: '',  //用户名
          password: '',  //密码
          repassword: '', //确认密码
          phone: '',  //手机号
          code: '',  //验证码
          showCountDown:false,//显示倒计时
          countDown: 60,  //倒计时
          loading:false,
          tip:'',
        }
      },
      methods: {
        sendSms(){
          if(!this.validatePhone()){
            this.$toast.fail(this.tip)
            return
          }
          this.showCountDown = true
          forgetPwdSms({
            nickname:this.nickname,
            mobile: this.phone,
            isForgetPassword:1
          }).then(response => {
            this.$toast.success(response.message)
            this.timer = setInterval(()=>{
              this.countDown--
              if(this.countDown === 0){
                this.showCountDown = false
                this.countDown = 60;
                clearInterval(this.timer)
              }
            },1000)
          }).catch(error => {
            console.log(error)
            this.showCountDown = false
          })
        },
        handleSubmit(){
          if(this.loading){
            return
          }
          if(!this.validatePhone() || !this.validateCode() || !this.validatePassword()){
            this.$toast.fail(this.tip)
            return
          }
          this.loading = true
          setting({
            password: this.password,
            repassword:this.repassword,
            mobile: this.phone,
            code: this.code,
            isForgetPassword:1
          }).then(response => {
            this.loading = false
            this.$dialog.alert({
              title: '提示',
              message: '修改成功！',
              theme: 'round-button',
            }).then(() => {
              // on close
              this.$router.push('/h5/login')
            })
          }).catch(error => {
            console.log(error)
            this.loading = false
          })
        },
        //清除文本框
        clear(val) {
          this[val] = ''
        },
        //监听手机
        checkPhone() {
          this.phone = this.phone.replace(/[^\d]/g, '')
        },
        // 验证手机
        validatePhone() {
          if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))) {
            this.tip = '手机号格式不正确'
            return false;
          }
          return true;
        },
        //验证密码
        validatePassword() {
          if (this.password.length < 6 || this.password.length >18) {
            this.tip = '密码长度6到18位'
            return false;
          }

          if (this.password != this.repassword) {
            this.tip = '两次密码输入不一致'
            return false
          }
          return true
        },
        //验证 验证码
        validateCode() {
          if (!(this.code.length == 6)) {
            this.tip = '验证码长度错误'
            return false;
          }
          return true
        },
        //跳转到登录界面
        toLogin() {
          this.$router.push('/h5/home')
        },
      }
    }
</script>

<style lang="less" scoped>
  /* 注册*/
  .reset-action{
    padding: 30px;
    font-family: Alibaba-PuHuiTi-R;
    .reset-title{
      font-size: 24px;
      color: #222222;
      text-align: center;
      padding-bottom: 10px;
    }
    .input-wrap,.code-wrap{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 7px 15px 7px 10px;
      background: #FFFFFF;
      border: 1px solid #EEEEEE;
      border-radius: 2px;
      margin-top: 20px;
      img{
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
    }
    .input-wrap{
      input {
        width: 90%;
        font-size: 15px;
        color: #222222;
        padding: 5px 5px 5px 10px;
        border: none;
      }
      input::-webkit-input-placeholder{
        font-size: 15px;
        color: #CCCCCC;
      }
    }
    .code-wrap{
      border: none;
      padding: 0;
      input{
        width: 80%;
        padding: 5px;
      }
      .text-wrap{
        width: 60%;
        height: 100%;
        border: 1px solid #EEEEEE;
        border-radius: 2px;
        padding: 5px 10px;
        white-space: nowrap;
      }
    }
    .code-btn,.clock-btn{
      width: 40%;
      height: 42px;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
      margin-left: 10px;
      color: #FFFFFF;
    }
    .code-btn{
      background: #FF8622;
    }
    .clock-btn{
      background: #E1E1E1;
    }
  }
  ::-webkit-input-placeholder {
    font-family: Alibaba-PuHuiTi-R;
    font-size: 14px;
    color: #CCCCCC;
    letter-spacing: 0;
  }
  .go-reset{
    cursor: pointer;
    color: #FFFFFF;
    background: #FF8622;
    margin-top: 40px;
    text-align: center;
    height: 48px;
    line-height: 48px;
    font-size: 18px;
  }
  /* 注册*/
</style>



// WEBPACK FOOTER //
// src/views/h5/resetPwd/Index.vue